module.exports = __webpack_public_path__ + "static/media/IconGrayLessons.5af70a18.svg";